var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPatientIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7083 5.83333H8.16667V0.291667C8.16667 0.13125 8.03542 0 7.875 0H6.125C5.96458 0 5.83333 0.13125 5.83333 0.291667V5.83333H0.291667C0.13125 5.83333 0 5.96458 0 6.125V7.875C0 8.03542 0.13125 8.16667 0.291667 8.16667H5.83333V13.7083C5.83333 13.8687 5.96458 14 6.125 14H7.875C8.03542 14 8.16667 13.8687 8.16667 13.7083V8.16667H13.7083C13.8687 8.16667 14 8.03542 14 7.875V6.125C14 5.96458 13.8687 5.83333 13.7083 5.83333Z",
    fill: "#1570EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPatientIcon);
export default __webpack_public_path__ + "static/media/add-patient-icon.0a5e699913a921f7e9804dfdaeade9f0.svg";
export { ForwardRef as ReactComponent };